import React from 'react'

import NewItemInputDialog from './NewItemInputDialog'

const FIELDS = [
  { display: 'Name', key: 'name', type: 'text', required: true },
  { display: 'Description', key: 'description', type: 'text' },
  { display: 'Rate', key: 'rate', type: 'number', step: '0.1', required: true },
  { display: 'Tax %', key: 'taxPercent', type: 'number', step: '1', required: false },
  { display: 'Quantity', key: 'quantity', type: 'number', step: '1', required: true }
]

export default class NewBillingItemDialog extends React.Component {

  render() {
    const props = Object.assign({}, this.props, {
      title: 'New Item',
      fields: FIELDS
    })
    return <NewItemInputDialog {...props} />
  }

}



// WEBPACK FOOTER //
// ./src/billing/common/modules/items/NewBillingItemDialog.js